/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const verifyReceiptDataSchema = z.object({
  verified: z.boolean(),
  transactionId: z.string(),
  subscription: z.object({
    planKey: z.string(),
    status: z.string(),
    platform: z.string(),
    expiresDate: z.number().nullable(),
  }),
});

export type IVerifyReceiptData = z.infer<typeof verifyReceiptDataSchema>;

export const verifyReceiptResponseSchema = createApiResponseSchema(
  verifyReceiptDataSchema,
) as z.ZodSchema<IAPI<IVerifyReceiptData>>;

export type IVerifyReceiptResponse = IAPI<IVerifyReceiptData>;
